type TNome = `${string}.pdf`

export class Pdf {
  static controller: AbortController | null = null //NOSONAR

  static readonly extension = (filename: string): TNome => {
    return filename.toLowerCase().endsWith('.pdf') ? (filename as TNome) : `${filename}.pdf`
  }

  static readonly extractFilename = (contentDisposition?: string) => {
    if (!contentDisposition) return null
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    const [_, filename] = filenameRegex.exec(contentDisposition) ?? []
    return filename ? Pdf.extension(filename) : null
  }

  static async download(blob: Blob, nome: TNome) {
    Pdf.controller?.abort()
    Pdf.controller = new AbortController()
    const { signal } = Pdf.controller

    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = nome
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    signal.addEventListener('abort', () => {
      URL.revokeObjectURL(url)
    })
  }

  static cancelDownload() {
    Pdf.controller?.abort()
    Pdf.controller = null
  }
}
